import { EMPLOYEE_PERMISSION_MODULES } from './modules';
import { PRESET_NONE } from './presetLevels';
import type { EmployeeModuleKey, PresetPermissions } from './types';

export type EbpInsertRow = {
  module: EmployeeModuleKey;
  can_view: boolean;
  can_edit: boolean;
  can_void: boolean;
  can_discount: boolean;
  can_manage_agenda: boolean;
  can_view_others: boolean;
  actions: Record<string, boolean>;
};

/** Build employee_branch_permissions insert rows from a permission map. */
export function ebpRowsFromPermissionSource(
  source: Partial<Record<EmployeeModuleKey, PresetPermissions>>
): EbpInsertRow[] {
  return EMPLOYEE_PERMISSION_MODULES.map((module) => {
    const p = source[module] ?? PRESET_NONE;
    return {
      module,
      can_view: p.canView,
      can_edit: p.canEdit,
      can_void: p.canVoid,
      can_discount: p.canDiscount,
      can_manage_agenda: p.canManageAgenda ?? false,
      can_view_others: p.canViewOthers ?? true,
      actions: p.actions ?? {},
    };
  });
}
